export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}form/question/`;
    const url = `${baseUrl}:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        import: {
            method: 'POST',
            url: `${url}/import`
        },
        // this should only be used to validate data
        dataDumpValidation: {
            method: 'GET',
            url: `${url}/data-dump-export`
        },
        questionsBySecondCategory: {
            method: 'GET',
            url: `${baseUrl}questions-by-second-category/:formId`,
            isArray: true
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Question/index.js